import React from 'react';
import ReactTimeAgo from 'react-time-ago';
import { RegularIcon } from '../common/icons/RegularIcon';

export const NotificationsListItem = ({ notification, onRemove }) => {
    return (
        <li className="notification-item list-group-item d-flex justify-content-between align-items-center">
            <div className="notification-icon">
                <RegularIcon
                    color={notification.type}
                    icon={notification.icon}
                    iconClassName="fa-fw"
                    className="me-3"
                    size="lg"
                />
            </div>
            <div className="notification-content me-auto">
                <h5 className="h5 mb-1">{notification.title}</h5>
                <p className="text-muted mb-1">{notification.message}</p>
                <small className="text-black-50 mb-1">
                    <ReactTimeAgo date={Date.parse(notification.date)} timeStyle="round" />
                </small>
            </div>
            <div className="notification-actions">
                <button
                    className="btn btn-sm btn-outline-secondary border-0 bg-white"
                    onClick={() => onRemove(notification)}>
                    <RegularIcon className="m-2" color="muted" icon="times" size="lg" />
                </button>
            </div>
        </li>
    );
};
